// extracted by mini-css-extract-plugin
module.exports = {"root":"ArchivalReasonPlaque_root__sbdva"};